__turbopack_context__.v({
  "imageContainer": "PrismicImageCard-module-scss-module__fbT0va__imageContainer",
});
